import { defineNuxtRouteMiddleware } from "#imports";

export default defineNuxtRouteMiddleware( async () => {
  // The store needs to check if we are still logged in
  const authStore = useAuthStore();
  const basketStore = useBasketStore();

  const loggedIn = await authStore.checkLogin();

  if ( !loggedIn && basketStore.linkedToWebAccount ) {
    // We are not logged in anymore and our copy of the basket is linked to
    // a web account so we need to detach it
    await basketStore.detachBasket();
  } else {
    // We are still logged in so make sure we are showing the correct basket
    await basketStore.checkBasket();
  }
} );
